// extracted by mini-css-extract-plugin
export default {"inBoxContainer":"r5DB3ir9ZoTO5HIPtWLx","scrollContainer":"N0bUbCNf8T7Xxb0yaEGL","outBox":"hqZE2FEZivpX_Wd9OXzH","leaderboardTable":"kXW7n9LXraPTiPSaZGS7"};